import fixDate from "./fix-date";

export function isStringEmpty(val?: string): boolean {
    return val === null || val === undefined || val === "";
}

export function isNumberEmpty(val?: number): boolean {
    return val === null || val === undefined || val.toString() === "";
}

export function isDateEmpty(val?: Date | null): boolean {
    return val === null || val === undefined || val.toString() === "0";
}

export function isDropdownEmpty(val?: number): boolean {
    return val === null || val === undefined || isNaN(val);
}

export function isYnDropdownEmpty(val?: boolean): boolean {
    return val === null || val === undefined;
}

export function areNotEqual(a: string | boolean | number, b: string | boolean | number): boolean {
    return a !== b;
}

export function areDatesNotEqual(a: Date, b: Date): boolean {
    return fixDate(a) !== fixDate(b);
}